import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "confirm-loading": _vm.confirmLoading,
      "title": _vm.t((_vm.addressId ? $t("\u7F16\u8F91") : $t("\u65B0\u589E")) + $t("\u53D1\u8D27\u5730\u5740")),
      "visible": _vm.modalVisible
    },
    on: {
      "cancel": _vm.handleCancel,
      "ok": _vm.handleOk
    }
  }, [_c('a-form-model', {
    ref: "formModel",
    attrs: {
      "model": _vm.addressForm,
      "rules": _vm.formDataRules
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8054\u7CFB\u4EBA"),
      "label": _vm.t('联系人'),
      "prop": "name"
    }
  }, [_c('my-input', {
    attrs: {
      "maxLength": 50
    },
    model: {
      value: _vm.addressForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addressForm, "name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "addressForm.name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8054\u7CFB\u7535\u8BDD"),
      "label": _vm.t('联系电话'),
      "prop": "phone"
    }
  }, [_c('my-input', {
    attrs: {
      "maxLength": 50
    },
    model: {
      value: _vm.addressForm.phone,
      callback: function ($$v) {
        _vm.$set(_vm.addressForm, "phone", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "addressForm.phone"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u56FD\u5BB6/\u5730\u533A"),
      "label": _vm.t('国家/地区'),
      "prop": "countries_and_regions"
    }
  }, [_c('my-select', {
    attrs: {
      "show-search": ""
    },
    model: {
      value: _vm.addressForm.countries_and_regions,
      callback: function ($$v) {
        _vm.$set(_vm.addressForm, "countries_and_regions", $$v);
      },
      expression: "addressForm.countries_and_regions"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('a-select-option', {
      key: item.name,
      attrs: {
        "value": item.name
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7701\u5DDE"),
      "label": _vm.t('省州'),
      "prop": "province"
    }
  }, [_c('my-input', {
    attrs: {
      "maxLength": 50
    },
    model: {
      value: _vm.addressForm.province,
      callback: function ($$v) {
        _vm.$set(_vm.addressForm, "province", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "addressForm.province"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u57CE\u5E02"),
      "label": _vm.t('城市'),
      "prop": "city"
    }
  }, [_c('my-input', {
    attrs: {
      "maxLength": 50
    },
    model: {
      value: _vm.addressForm.city,
      callback: function ($$v) {
        _vm.$set(_vm.addressForm, "city", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "addressForm.city"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8BE6\u7EC6\u5730\u5740"),
      "label": _vm.t('详细地址'),
      "prop": "detailedaddress"
    }
  }, [_c('my-input', {
    attrs: {
      "maxLength": 50
    },
    model: {
      value: _vm.addressForm.detailedaddress,
      callback: function ($$v) {
        _vm.$set(_vm.addressForm, "detailedaddress", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "addressForm.detailedaddress"
    }
  })], 1)], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };